module.exports = __webpack_public_path__ + "static/quick-oauth-credentials.6197c5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/realfire/features/oauth-and-credentials/quick-oauth-credentials.png
// module id = 220
// module chunks = 62430881213916 95704636617618